(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-announcement-bar-section-script');
    if (!window.announcementSectionBar && $url) {
      window.announcementSectionBar = $url.value;
      let $script = document.createElement('script');
      $script.src = window.announcementSectionBar;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["audience-fit"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-audience-fit-script')
    if (!window.audienceFit && $url) {
      window.audienceFit = $url.value

      var $script = document.createElement('script')
      $script.src = window.audienceFit
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('speakon-blog-posts')) {
    customElements.define('speakon-blog-posts', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const track = this.querySelector('[data-track]');
        const cards = [...this.querySelectorAll('[data-card]')];
        const controls = this.querySelector('[data-controls]');
        const previous = this.querySelector('[data-step="-1"]');
        const next = this.querySelector('[data-step="1"]');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        if (!track || !cards.length) return;
        const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        const position = () => direction * track.scrollLeft;
        const maxScroll = () => {
          const box = track.getBoundingClientRect();
          const last = cards[cards.length - 1].getBoundingClientRect();
          const style = getComputedStyle(track);
          const padding = parseFloat(direction === 1 ? style.paddingRight : style.paddingLeft);
          return Math.max(0, position() + (direction === 1 ? last.right - box.right : box.left - last.left) + padding);
        };
        const scrollTo = (left, instant = false) => track.scrollTo({
          left: direction * Math.max(0, Math.min(left, maxScroll())),
          behavior: instant || reduced.matches ? 'instant' : 'smooth'
        });
        const update = () => {
          const end = maxScroll();
          if (position() > end + 1) scrollTo(end, true);
          controls.hidden = end <= 1;
          previous.disabled = position() <= 1;
          next.disabled = position() >= end - 1;
        };
        const move = (step, instant) => scrollTo(position() + step * (cards[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap)), instant);
        track.addEventListener('scroll', update, { ...options, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-step]');
          if (button) move(Number(button.dataset.step), event.detail === 0);
        }, options);
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight') move(direction, true);
          else if (event.key === 'ArrowLeft') move(-direction, true);
          else if (event.key === 'Home') scrollTo(0, true);
          else if (event.key === 'End') scrollTo(maxScroll(), true);
          else return;
          event.preventDefault();
        }, options);
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
        update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["circular-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-circular-carousel-script')
    if (!window.circularCarousel && $url) {
      window.circularCarousel = $url.value

      var $script = document.createElement('script')
      $script.src = window.circularCarousel
      $script.defer = "defer"
      document.body.appendChild($script)
    }

    if (!window._ytLazyModal) {
      window._ytLazyModal = true;
      document.addEventListener('show.bs.modal', function(e) {
        var iframe = e.target.querySelector('iframe[data-src]');
        if (iframe) iframe.src = iframe.dataset.src;
      });
      document.addEventListener('hidden.bs.modal', function(e) {
        var iframe = e.target.querySelector('iframe[data-src]');
        if (iframe) iframe.src = '';
      });
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creativity-spot-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-spot-cards-script')
    if (!window.spotCards && $url) {
      window.spotCards = true

      var $script = document.createElement('script')
      $script.src = $url.value
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-roadmap"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-feature-roadmap-section-script');
    if (!window.featureRoadmapSectionScript && $url) {
      window.featureRoadmapSectionScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.featureRoadmapSectionScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-with-cards-script')
    if (!window.imageTab && $url) {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid-slide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-media-grid-slide-section-script');
    if (!window.mediaGridSlideSectionScript && $url) {
      window.mediaGridSlideSectionScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.mediaGridSlideSectionScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-v2-script')
    if (!window.autoCardsScroller && $url) {
      window.autoCardsScroller = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.autoCardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-scale"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-scale-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meida-scale"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-scale-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-promotion-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-product-promotion-card-section-script');
    if (!window.productPromotionCardSectionScript && $url) {
      window.productPromotionCardSectionScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.productPromotionCardSectionScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  (function () {
    let $url = document.querySelector('.as-quick-view-product-purchase-card-script');
    if (!window.quickViewProductPurchaseCardScript && $url) {
      window.quickViewProductPurchaseCardScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.quickViewProductPurchaseCardScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view-purchase-section"]) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-quick-view-product-purchase-popup-script');
    if (!window.quickViewPurchaseSectionScript && $url) {
      window.quickViewPurchaseSectionScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.quickViewPurchaseSectionScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  (function () {
    let $url = document.querySelector('.as-quick-view-product-purchase-card-script');
    if (!window.quickViewProductPurchaseCardScript && $url) {
      window.quickViewProductPurchaseCardScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.quickViewProductPurchaseCardScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-tab-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenario-tab-cards-script')
    if (!window.scenarioTabCards && $url && $url.dataset.designMode !== 'yes') {
      window.scenarioTabCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.scenarioTabCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-unlock-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scroll-unlock-cards-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-scene-and-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-scene-and-carousel-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-scrolling-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-side-scrolling-gallery-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video"] && !Shopify.designMode) return;
  try {
    
  if (!window._ytLazyModal) {
    window._ytLazyModal = true;
    document.addEventListener('show.bs.modal', function(e) {
      var iframe = e.target.querySelector('iframe[data-src]');
      if (iframe) iframe.src = iframe.dataset.src;
    });
    document.addEventListener('hidden.bs.modal', function(e) {
      var iframe = e.target.querySelector('iframe[data-src]');
      if (iframe) iframe.src = '';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["software-ordering"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-software-ordering-section-script');
    if (!window.softwareOrderingSectionScript && $url) {
      window.softwareOrderingSectionScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.softwareOrderingSectionScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-width-video"] && !Shopify.designMode) return;
  try {
    
  if (!window._ytLazyModal) {
    window._ytLazyModal = true;
    document.addEventListener('show.bs.modal', function(e) {
      var iframe = e.target.querySelector('iframe[data-src]');
      if (iframe) iframe.src = iframe.dataset.src;
    });
    document.addEventListener('hidden.bs.modal', function(e) {
      var iframe = e.target.querySelector('iframe[data-src]');
      if (iframe) iframe.src = '';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
